import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../utils/hooks/useMutationWithError";
import {
  UserContactStatus,
  useCheckUserEmailStatusProfileMutation,
} from "./__generated__/useCheckUserEmailStatusProfileMutation.graphql";

export const useCheckUserEmailStatusProfile = () => {
  const [checkStatus, isChecking] =
    useMutationWithError<useCheckUserEmailStatusProfileMutation>(
      useCheckEmailProfileMutationString
    );

  const checkEmail = (
    email: string,
    onCompleteHandler: (
      value: string,
      result: UserContactStatus,
      type: "Email"
    ) => void
  ) => {
    checkStatus({
      variables: { input: { email } },
      onCompleted: (res) => {
        if (res.responsePayload?.success && res.responsePayload.result) {
          onCompleteHandler(email, res.responsePayload.result, "Email");
        }
      },
    });
  };
  return [checkEmail, isChecking] as const;
};

export const useCheckEmailProfileMutationString = graphql`
  mutation useCheckUserEmailStatusProfileMutation(
    $input: UserEmailStatusInput!
  ) {
    responsePayload: userEmailStatus(input: $input) {
      success
      result
      errors {
        field
        code
        message
      }
    }
  }
`;
